<template>
    <div class="certificate-card">
        <div class="certificate-card__header">
            <p class="certificate-card__number">
                {{ result.certificate }}
            </p>
            <span
                class="certificate-card__remove"
                @click="handlerRemoveCertificate"
            >
                <svg class="certificate-card__icon"><use xlink:href="#svg-trash"></use></svg>
            </span>
        </div>
        <p class="certificate-card__discount">
           {{ result.discount }}
        </p>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'CertificateCard',
    selector: '.certificate-card',
    props: ['result'],
    methods: {
        ...mapActions({
            deleteCertificate: 'basket/deleteCertificate',
            setAjax: 'checkout/setAjax'
        }),
        async handlerRemoveCertificate() {
            await this.deleteCertificate(this.result.certificate);
            this.setAjax();
        }
    }
}
</script>

<style lang="scss" scoped>
.certificate-card{
    &__header{
        display: flex;
        align-items: center;
        margin: 16px 0 8px;
    }
    &__number{
        padding: 6px 8px;
        font-weight: 500;
        font-size: rem(12);
        line-height: 120%;
        color: var(--color-green);
        border: 1px dashed var(--background-green);
        background-color: #E4EEE7;
    }
    &__icon{
        width: 16px;
        height: 16px;
        transition: .2s linear fill;
    }
    &__remove{
        cursor: pointer;
        width: 16px;
        height: 16px;
        margin-left: 8px;
        &:hover{
            .certificate-card__icon{
                fill: var(--background-red);
            }
        }
    }
    &__discount{
        font-weight: 500;
        font-size: rem(12);
        line-height: 120%;
        color: #5F5F67;
        margin-bottom: 16px;
    }
}
</style>